// 全局门户数据api
import { getmh } from '@/utils/http'

var apI = '/api/v1'

// 门户数据字典
export const getFeginDictData = (data) => {
  return getmh(apI + '/feign/dictData/getDictDataByDictId', data)
}

//行政区域树
export const getAreaCodeTree = (data) => {
  return getmh(apI + '/feign/area/areaList/tree',data)
}

//行政区域列表
export const getAreaCodeList = (data) => {
  return getmh(apI + '/feign/area/areaList',data)
}

//组织机构树
export const getOrgCodeTree = (data) => {
  return getmh(apI + '/feign/org/currentApp/treeList2', data)
}

//获取门户部门信息
export const getFeginOrg = (data) => {
  return getmh(apI + '/feign/org/' + data)
}

//获取人员信息列表
export const getPersonByOrgId = (data) => {
  return getmh(apI + '/person/orgPersonList', data)
}

//获取行政区域树-根据父id
export const getFeignAreaListTree = (data) => {
  return getmh(apI + '/feign/area/areaList/tree',data)
}

export default {
  getFeginDictData,
  getAreaCodeTree,
  getAreaCodeList,
  getOrgCodeTree,
  getFeginOrg,
  getPersonByOrgId,
  getFeignAreaListTree
}



// WEBPACK FOOTER //
// ./src/api/gate/apiDict.js